<template>
    <div class="page bg-gray page-flex" style="padding-bottom: 0;">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-20" placeholder="搜索订单号" v-model="pageInfo.orderNo">
            <div @click="showPicker = true" class="fs-28">
                <input type="search" @focusin="showPicker = true" class="in-txt v-picker center-input fs-20" placeholder="选择小区" v-model="orgInf.orgName">

            </div>
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>

        <div class="page-state">
            <van-tabs v-model="tabActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
                <van-tab :title="item.title" :name="item.value" v-for="(item,$index) in tabList" :key="$index"></van-tab>
            </van-tabs>
        </div>
        <div class="flex1 posi-rel ">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <ul class="pt-10">
                    <li v-for="(item,$index) in data" :key="$index" class="flex-center click">
                        <div class="alifont pd-20 fs-48" :class="item.selected?'icon-xuanzhong color-main':'icon-weixuanzhong color-999'" @click="chooseOrder(item,$index)"></div>
                        <div class="order-item flex1 ofh" @click="getScrollerPosition();$router.push({name:'orderDetail',query:{orderId: item.orderId}})">
                            <div class="">
                                <div class="flex-center address-box">
                                    <div class="alifont icon-dizhi"></div>
                                    <div class="flex1">
                                        <div class="fs-28 color-333">{{item.userAddress}}</div>
                                        <div class="flex fs-28 color-999 mt-5">
                                            <div class="mr-30">{{item.userName}}</div>
                                            <div>{{item.userMobile}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-between fs-28 pd-250 bd-top" v-if="item.transportTime">
                                <div class="color-999">期望送达时间</div>
                                <div class="color-main">{{item.transportTime}}</div>
                            </div>

                            <div class="product-list">
                                <div v-if="item.productList.length == 1">
                                    <div class="product-item flex-center pd-100" v-for="(prod,prodIndex) in item.productList" :key="prodIndex" >
                                        <div class="product-img"><img :src="prod.imgPathView" alt=""></div>
                                        <div class="product-info flex1 ofh">
                                            <div class="fs-24 color-000 text-el mt-5">{{prod.productName}}</div>
                                            <div class="fs-22 color-999 mt-5" v-if="prod.specName">{{prod.specName}}</div>
                                            <div class="flex-between fs-24 color-999 mt-8">
                                                <div>¥{{prod.salePrice}}</div>
                                                <div>x{{prod.productQty}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-between flex-center" v-else>
                                    <div class="product-item-img-box flex-center">
                                        <div class="product-img mr-10" v-for="(prod,prodIndex) in item.productList" :key="prodIndex" v-if="prodIndex<4">
                                            <img :src="prod.imgPathView" alt="">
                                        </div>
                                    </div>
                                    <div class="fs-24 color-999">共{{item.productList.length || 0}}件</div>
                                </div>

                            </div>
<!--                            <div class="pd-250 flex-between flex-center fs-28 bd-bot">-->
<!--                                <div>-->
<!--                                    <span class="color-999">顾客：{{item.nickname}}</span>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <span class="color-999"></span>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="pd-250 fs-28 color-999">
                                <div class="flex-center flex-between fs-26">
                                    <div>订单号：{{item.orderNo}}</div>
                                    <div :class="item.printState == '1'?'color-main':'color-333'">{{item.printState == '1'?'已打印':'未打印'}}</div>
                                </div>
                                <div class="mt-8 flex-between fs-26">
                                    <div>下单时间：{{new Date(item.orderCommitTime.replace(/-/g, '/')).Format('MM-dd hh:mm')}}</div>
                                    <div>合计：<span class="color-333">¥{{item.receivable}}</span></div>
                                </div>
                                <div class="fs-26 flex-between mt-8" v-if="item.dmMobile || item.dmName">
                                    <div>配送员：<span class="color-333">{{item.dmName}}</span></div>
                                    <div @click.stop="makeCall(item.dmMobile)">联系方式：<span class="color-333">{{item.dmMobile}}</span></div>
                                </div>
                                <div class="mt-8 bd-top pt-25 " v-if="item.remark">备注：<span class="color-333">{{item.remark}}</span></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </scroller>
        </div>
        <div class="com-fixed-bot">
            <div class="flex-center flex1 click" @click="chooseAll()">
                <div class="alifont fs-48" :class="isChooseAll?'icon-xuanzhong color-main':'icon-weixuanzhong color-999'"></div>
                <div class="fs-30 color-333 ml-20">全选</div>
            </div>
            <div class="btn gray click" @click="printOrderNet">打印订单</div>
            <div class="btn green click" @click="sendOrder">发货</div>
        </div>


        <van-action-sheet v-model="actionsSheetShow" :actions="actions" cancel-text="取消" close-on-click-action description="请选择发货类型" @select="onSelect" />

        <van-popup v-model="expressPopShow" position="bottom">
            <van-picker
                v-if="expressPopShow"
                show-toolbar
                title="选择物流"
                :columns="dicts['express_type'] || []"
                value-key="codename"
                :default-index="expressDefaultIndex"
                @cancel="expressPopShow = false"
                @confirm="onExpressConfirm"
            />
        </van-popup>

        <!-- 小区 -->
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="columns"
                    value-key="orgName"
                    @confirm="onConfirm"
                    @cancel="onCancel"
            />
        </van-popup>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import initDict from '@/mixins/initDict'
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import printOrder from "@/mixins/printOrder";
    import { batchUpdateOrderStatus, sendOrder } from "@/api/order"
    import { selectAllOrg} from "@/api/shop"
    import { getAgentId } from "@/utils/util";

    export default {
        name: "orderList",
        mixins: [initData,routerBack,initDict,getAppStatusHeight,printOrder],
        components:{appStatus},
        data(){
            return {
                tabList:[
                    {title:'未打印',value:'3'},
                    {title:'已打印',value:'2'},
                    {title:'全部',value:'1'},
                ],
                tabActive: '3',
                actions:[],
                orgInf: {orgId:''},
                showPicker: false,
                columns: [],
                actionsByJishida: [{ name: '同城快递', subname: '达达、美团' }, { name: '自营物流', subname: '选择物流，默认自营' }],
                actionsByOnlineShop: [{ name: '普通快递', subname: '需填写物流单号' }, { name: '同城快递', subname: '达达、美团' }, { name: '自营物流', subname: '选择物流，默认自营' }],
                shopId: this.$store.state.user.shopId,
                isChooseAll:false,
                printState:0,
                actionsSheetShow:false,
                selectOrderList:[],
                expressPopShow: false,
                expressDefaultIndex: 0,
                expressForm: {},
            }
        },
        created(){
            // 加载数据字典
            let codeList = [
                'orderStatus',
                'express_type',
            ]
            this.getThisDict(codeList);
            this.getOrgs();
        },
        watch: {
            'dicts.express_type'(list) {
                if (list && list.length) {
                    this.initDefaultExpress();
                }
            }
        },
        methods:{
            back(){
                if(this.isBackClose){
                    try{
                        window.native.onFinish();
                    }catch (e) {

                    }
                }else{
                    try{
                        window.native.onBack();
                    }catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            beforeInit() {
                //
                if(this.printState == '3'){
                    this.params = { page : this.page, limit: this.limit,shopId:this.shopId,printState:this.printState,orderStatus:2,shipStatus:1,orgId:this.orgInf.orgId};
                }else{
                    this.params = { page : this.page, limit: this.limit,shopId:this.shopId,printState:this.printState,orderStatus:2,orgId:this.orgInf.orgId};
                }

                this.url = 'order/orderBase/list';
                let query = this.pageInfo;
                for (var key in query){
                    if(query[key]){
                        this.params[key] = query[key]
                    }
                }
                return true
            },
            //切换状态
            tabClick(name){
                switch (name) {
                    case '1':
                        this.printState = null;
                        break;
                    case '2':
                        this.printState = 1;
                        break;
                    case '3':
                        this.printState = 0;
                        break;
                }
                this.handleQuery();
            },

            onCancel(){
                this.showPicker = false;
                this.orgInf = {orgName:"选择小区",orgId:''};
                //this.handleQuery();
            },

            //加载小区
            getOrgs() {
                var agentId = getAgentId();

                selectAllOrg(agentId).then((res) => {
                    this.columns = res.data;
                    //this.orgInf = res.data[0] || {};
                });
            },
            //选择订单
            chooseOrder(data,$index){
                this.$set(this.data[$index],'selected',!this.data[$index].selected);
                this.judgeIsChooseAll();
            },

            onConfirm(value, index) {
                this.orgInf = this.columns[index];
                this.showPicker = false;
                this.data = {};
                this.handleQuery();
            },
            //全选
            chooseAll(){
                this.isChooseAll = !this.isChooseAll;
                this.data.forEach(item=>{
                    this.$set(item,'selected',this.isChooseAll)
                })
            },
            //判断是否已全选
            judgeIsChooseAll(){
                let bol = true;
                this.data.forEach(item=>{
                   if(!item.selected){
                       bol = false;
                       return
                   }
                })
                this.isChooseAll = bol;
            },

            loadMore(done) {
                setTimeout(() => {
                    if (this.noDate) {
                        this.$refs.scroller.finishInfinite(true);
                    } else {
                        this.page++;//下拉一次页数+1
                        this.isChooseAll = false;
                        this.init(done);
                    }
                }, 200);

            },

            //发货订单
            sendOrder(){
                let array = [];
                this.data.forEach(item=>{
                    if(item.selected){
                        array.push(item);
                    }
                })
                this.selectOrderList = array
                if(array.length == 0){
                    this.$toast('请选择订单');
                    return
                }else{
                    let _this = this;
                    let selectOrderTypeList = array.map(item=>{
                        return item.orderType
                    })
                    selectOrderTypeList = selectOrderTypeList.removeSameEle();  //移除数组内相同元素
                    if(selectOrderTypeList.length == 1){
                        this.openExpressPicker();
                    }else{
                        this.$dialog.alert({
                            message: '不同类型订单不可批量操作',
                        });
                    }
                }
            },

            //选择动作面板回调
            onSelect(item) {
                let name = item.name;
                let _this = this;
                switch (name) {
                    case '同城快递':
                        _this.sendOrderAjax(1,'确定此订单同城快递发货（通知达达或美团收件）？')
                        break;
                    case '自营物流':
                        _this.initDefaultExpress();
                        _this.expressPopShow = true;
                        break;
                    case '普通快递':
                        if(_this.selectOrderList.length > 1){
                            _this.$dialog.alert({
                                message: '普通快递发货只能选择一个订单',
                            });
                        }else{
                            _this.actionsSheetShow = false;
                            _this.$router.push({name:'sendOrder',query:{orderId: _this.selectOrderList[0].orderId}})
                        }
                        break;
                }

            },

            openExpressPicker() {
                this.initDefaultExpress();
                if (!this.expressForm.expressType) {
                    this.$toast('物流字典未加载，请稍后重试');
                    return;
                }
                this.expressPopShow = true;
            },
            initDefaultExpress() {
                const list = this.dicts['express_type'] || [];
                const ziyingIndex = list.findIndex(item => item.code === 'ziying');
                const target = ziyingIndex > -1 ? list[ziyingIndex] : list[0];
                if (target) {
                    this.expressDefaultIndex = ziyingIndex > -1 ? ziyingIndex : 0;
                    this.expressForm = {
                        expressType: target.code,
                        expressName: target.codename
                    };
                }
            },
            onExpressConfirm(value) {
                this.expressForm = {
                    expressType: value.code,
                    expressName: value.codename
                };
                this.expressPopShow = false;
                this.confirmExpressShip();
            },
            confirmExpressShip() {
                let _this = this;
                if (!_this.expressForm.expressType) {
                    _this.$toast('请选择物流');
                    return;
                }
                _this.$dialog.alert({
                    title: '提示',
                    message: `确定使用「${_this.expressForm.expressName}」发货？`,
                    showCancelButton: true
                }).then(() => {
                    _this.shipOrdersViaExpress();
                }).catch(() => {});
            },
            shipOrdersViaExpress() {
                let _this = this;
                let tasks = _this.selectOrderList.map(order => sendOrder({
                    orderId: order.orderId,
                    expressType: _this.expressForm.expressType,
                    expressName: _this.expressForm.expressName,
                    waybillNo: '',
                    orderStatus: 3
                }));
                Promise.all(tasks).then(results => {
                    let failed = results.find(res => res.code !== 0);
                    if (failed) {
                        _this.$toast(failed.msg || '部分订单发货失败');
                        return;
                    }
                    _this.$toast('操作成功');
                    _this.handleQuery();
                }).catch(() => {
                    _this.$toast('发货失败，请重试');
                });
            },

            sendOrderAjax(deliveryType,msg){
                //deliveryType  配送方式 0自营配送 1物流配送
                let _this = this;
                let array = this.selectOrderList;
                this.$dialog.alert({
                    title: "提示",
                    message: msg || "确定此订单发货？",
                    showCancelButton: true
                }).then(() => {     //点击确认按钮后的调用
                        let params = {
                            orderIds: array.map(item=>{
                                return item.orderId
                            }).join(","),
                            orderStatus: 3,
                            deliveryType: deliveryType
                        }
                        batchUpdateOrderStatus(params).then(res=>{
                            _this.$toast('操作成功');
                            _this.handleQuery();
                        })
                    }).catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            },
            makeCall(phone){
                if(phone){
                    window.location.href = 'tel://' + phone
                }
            },
        },

        beforeRouteEnter(to, from, next) {
            if ( from.name == 'orderDetail' || from.name == 'sendOrder') {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack || this.$store.state.updateOrderList) {
                this.$store.state.updateOrderList = false;
                if(this.hasAlive){
                    this.handleQuery();

                }
            }
            this.actionsSheetShow = false;
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .page-state{
        top: .9rem;
    }
    .fs-48{
        font-size: .48rem;
    }
    .order-item{
        margin: .1rem .24rem .1rem 0;
        background: #fff;
        padding: 0 .24rem;
        border-radius: .12rem;
        .product-img{
            width: 1rem;
            height: 1rem;
            margin-right: .24rem;
            &.mr-10{
                margin-right: .1rem;
            }
        }
        .name{
            height: .8rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }
    .btn-group{
        padding: .18rem 0;
        display: flex;
        justify-content: flex-end;
        .btn{
            width: 1.64rem;
            height: .56rem;
            text-align: center;
            line-height: .56rem;
            background: #fff;
            border-radius: .12rem;
            font-size: .26rem;
            color: $main-color;
            margin-left: .2rem;
            border: .01rem solid $main-color;
            &.active{
                background: $main-color;
                color: #fff;
            }
        }
    }
    .address-box{
        padding: .24rem 0 .1rem;
        .alifont{
            font-size: .68rem;
            color: $main-color;
            margin-right: .1rem;
        }
    }

    .com-fixed-bot{
        height: .98rem;
        background: #fff;
        padding: .11rem .24rem;
        display: flex;
        align-items: center;
        .btn{
            width: 2.4rem;
            height: 100%;
            text-align: center;
            line-height: .76rem;
            border-radius: .12rem;
            margin-left: .24rem;
            font-size: .3rem;
            &.gray{
                background: #F4F4F4;
                color: $main-color;
            }
            &.green{
                background: $main-color;
                color: #fff;
            }
        }
    }

    .product-list{
        background: #FAFAFA;
        border-radius: .08rem;
        padding: .16rem;
    }


    .v-input {
        flex: 1;
        height: 0.64rem;
        border-radius: 0.32rem;
        padding: 0.12rem 0.3rem;
        color: #333;
        border: none;
        outline: none;
    }

    .in-txt {
        border: 1px solid #ddd;
        background-color: #fff;
        color: #333;
        width: 2.2rem;
        text-align: center;
    }
    .v-picker {
        width: 2rem;
        margin-right: 2px;
    }

</style>



// WEBPACK FOOTER //
// waitSendOrderList.vue?bbe9858a